import React from 'react';
import TV from '../../../../static/images/Tv_mpbile.png';
import TVwebp from '../../../../static/images/Tv_mpbile.webp';
import MobileStoreButton from '@ertelecom/ui-react/components/buttons/mobileStoreButton';

import { Bonus, Title, Text, Img, WrapperMobileBtn, WrapperText, Picture, Source } from './styled';

class BonusMobTv extends React.PureComponent {

    state = {
        isScrolled: false
    };

    render() {

        const { isScrolled } = this.state;
        const { titleTag } = this.props;

        return (
            <Bonus isScrolled={isScrolled} itemScope itemType='http://schema.org/ImageObject'>
                {
                    isScrolled &&
                    <Picture>
                        <Source srcSet={TVwebp} type='image/webp' />
                        <Img src={TV} alt='Амедиатека в пакете интернет и ТВ' title='Амедиатека в пакете интернет и ТВ' itemProp='contentUrl' />
                    </Picture>
                }
                <WrapperText>
                    <Title itemProp='name' as={titleTag}>Мобильное ТВ бесплатно на всех тарифах при подключении</Title>
                    <Text itemProp='description'>С Дом.ру ТВ-каналы всегда под рукой. Смотрите любимые телепередачи на смартфоне по дороге на работу. Включите детям мультики на ноутбуке, и пусть они смотрят их на заднем сиденье автомобиля. А жена не отрывается от любимого сериала на маникюре, а смотрит его с планшета.</Text>
                    <WrapperMobileBtn>
                        <MobileStoreButton rel='nofollow noopener noreferrer' store='MovixAppStore' target='_blank' color='#fff' />
                        <MobileStoreButton store='MovixGooglePlay' target='_blank' color='#fff' />
                    </WrapperMobileBtn>
                </WrapperText>
            </Bonus>
        );
    }

    componentDidMount() {

        if (document.documentElement.scrollTop > 0) {
 this.setState({ isScrolled: true });
}

        if (process.browser) {
            window.addEventListener('scroll', this.loadIage);
        }
    }

    loadIage = () => {
        this.setState({ isScrolled: true });
        window.removeEventListener('scroll', this.loadIage);
    };

    componentWillUnmount() {
        if (process.browser) {
            window.removeEventListener('scroll', this.loadIage);
        }
    }
}

export default BonusMobTv;
